<template>
   <section class="content">
    <div class="container-fluid">
        <div class="row">

          <div class="col-12">
        
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Daftar Router</h3>

                <div class="card-tools">
                  
                  <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      Tambah
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nama</th>
                      <th>IP / IPv6</th>
                      <th>Port</th>
                      <th>Password</th>
                      <th>Keterangan</th>
                      <th>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in routers.data" :key="row.id">

                      <td>{{index+1}}</td>
                      <td>{{row.shortname}}</td>
                      <td>{{row.nasname}} / {{row.ipv6}}</td>
                      <td>{{row.ports}}</td>
                      <td>{{row.secret}}</td>
                      <td>{{row.description}}</td>
                      <!-- <td><img v-bind:src="'/' + product.photo" width="100" alt="product"></td> -->
                      <td>
                        
                        <a href="#" @click="editModal(row)">
                            <i class="fa fa-edit blue"></i>
                        </a>
                        /
                        <a href="#" @click="deleteRouter(row.id)">
                            <i class="fa fa-trash red"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="routers" @pagination-change-page="getResults"></pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Tambah Router</h5>
                    <h5 class="modal-title" v-show="editmode">Edit Router</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="editmode ? updateRouter() : createRouter()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Nama</label>
                            <input v-model="form.shortname" type="text" name="shortname"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('shortname') }">
                            <has-error :form="form" field="shortname"></has-error>
                        </div>
                        <div class="form-group">
                            <label>IP</label>
                            <input v-model="form.nasname" type="text" name="nasname"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('nasname') }">
                            <has-error :form="form" field="nasname"></has-error>
                        </div>
                        <div class="form-group">
                            <label>IPv6</label>
                            <input v-model="form.ipv6" type="text" name="ipv6"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('ipv6') }">
                            <has-error :form="form" field="ipv6"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Port</label>
                            <input v-model="form.ports" type="text" name="ports"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('ports') }">
                            <has-error :form="form" field="ports"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Password</label>
                            <input v-model="form.secret" type="text" name="secret"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('secret') }">
                            <has-error :form="form" field="secret"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Keterangan</label>
                            <input v-model="form.description" type="text" name="description"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('description') }">
                            <has-error :form="form" field="description"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Edit!</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Tambah!</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                editmode: false,
                routers : {},
                form: new Form({
                    id : '',
                    shortname : '',
                    nasname: '',
                    ipv6: '',
                    ports: '',
                    description: '',
                    secret: '',
                })
            }
        },
        methods: {

          getResults(page = 1) {

              this.$Progress.start();
              
              axios.get('api/router?page=' + page).then(({ data }) => (this.routers = data.data));

              this.$Progress.finish();
          },
          loadRouter(){

            // if(this.$gate.isAdmin()){
              axios.get("api/router").then(({ data }) => (this.routers = data.data));
            // }
          },
          editModal(router){
              this.editmode = true;
              this.form.reset();
              $('#addNew').modal('show');
              this.form.fill(router);
          },
          newModal(){
              this.editmode = false;
              this.form.reset();
              $('#addNew').modal('show');
          },
          createRouter(){
              this.$Progress.start();

              this.form.post('api/router')
              .then((data)=>{
                if(data.data.success){
                  $('#addNew').modal('hide');

                  Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                  this.$Progress.finish();
                  this.loadRouter();

                } else {
                  Toast.fire({
                      icon: 'error',
                      title: 'Some error occured! Please try again'
                  });

                  this.$Progress.fail();
                }
              })
              .catch(()=>{

                  Toast.fire({
                      icon: 'error',
                      title: 'Some error occured! Please try again'
                  });
              })
          },
          updateRouter(){
              this.$Progress.start();
              this.form.put('api/router/'+this.form.id)
              .then((response) => {
                  // success
                  $('#addNew').modal('hide');
                  Toast.fire({
                    icon: 'success',
                    title: response.data.message
                  });
                  this.$Progress.finish();
                      //  Fire.$emit('AfterCreate');

                  this.loadRouter();
              })
              .catch(() => {
                  this.$Progress.fail();
              });

          },
          deleteRouter(id){
              Swal.fire({
                  title: 'Yakin untuk menghapus?',
                  text: "Router yang memiliki Pengguna Terhubung tidak dapat dihapus!. Yakin untuk Menghapus Router?",
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Ya, Hapus!'
                  }).then((result) => {

                      // Send request to the server
                        if (result.value) {
                              this.form.delete('api/router/'+id).then(()=>{
                                      Swal.fire(
                                      'Terhapus!',
                                      'Data Router Berhasil Dihapus.',
                                      'success'
                                      );
                                  // Fire.$emit('AfterCreate');
                                  this.loadRouter();
                              }).catch((data)=> {
                                  Swal.fire("Hapus Gagal!", data.message, "warning");
                              });
                        }
                  })
          },

        },
        mounted() {
            
        },
        created() {
            this.$Progress.start();

            this.loadRouter();

            this.$Progress.finish();
        }
    }
</script>